// extracted by mini-css-extract-plugin
export default {"priceHistoryDetailedChartContainer":"PriceHistoryMobileDetailedChart__priceHistoryDetailedChartContainer"};